<div
  class="group flex w-max min-w-64 gap-1 rounded-xl p-1 transition-colors select-none"
  [class.flex-col]="layout() === 'VERTICAL'"
  [class.flex-row]="layout() === 'HORIZONTAL'"
  [class]="twBackground()"
  (click)="isClickable() ? clicked.emit() : undefined"
>
  @if (image(); as image) {
    <img
      [src]="image"
      [alt]="text()"
      class="w-xs rounded-lg transition-colors select-none"
      [class]="{
        grayscale: state() === 'DISABLED',
      }"
      (dragstart)="(false)"
    />
  }

  @if (audio(); as audio) {
    <div
      class="font-family-din w-full place-content-center rounded-lg p-4 text-center text-4xl font-normal transition-colors"
      [class]="{
        'bg-card-background': state() === 'DEFAULT',
        'bg-slate-100': state() === 'DISABLED',
        'bg-red-100': state() === 'INCORRECT',
        'bg-emerald-100': state() === 'CORRECT',
        'text-emerald-500': state() === 'CORRECT',
        'text-red-500': state() === 'INCORRECT',
        'text-text-primary': state() === 'DEFAULT',
        'text-slate-300': state() === 'DISABLED',
        'group-hover:text-blue-500': isClickable() && state() === 'DEFAULT',
      }"
    >
      <rid-audio-button #audioButton [src]="audio" size="SMALL" />
    </div>
  }

  @if (text(); as text) {
    <div
      class="font-family-din w-full place-content-center rounded-lg p-4 text-center text-4xl font-normal transition-colors"
      [class]="{
        'bg-card-background': state() === 'DEFAULT',
        'bg-slate-100': state() === 'DISABLED',
        'bg-red-100': state() === 'INCORRECT',
        'bg-emerald-100': state() === 'CORRECT',
        'text-emerald-500': state() === 'CORRECT',
        'text-red-500': state() === 'INCORRECT',
        'text-text-primary': state() === 'DEFAULT',
        'text-slate-300': state() === 'DISABLED',
        'group-hover:text-blue-500': isClickable() && state() === 'DEFAULT',
      }"
    >
      {{ text }}
    </div>
  }
</div>
